module.exports = __webpack_public_path__ + "static/media/deposit.d8d94d9a.svg";